module.exports = __webpack_public_path__ + "img/chengben.6eee5365.png";